import styles from './avatar-editable.module.less';
import { Icon } from '@sb1/ffe-icons-react';
import { useState } from 'react';
import editIcon from '@sb1/ffe-icons/icons/open/300/sm/edit.svg';
import CropImage from '../crop-image/CropImage';
import Dropzone from 'react-dropzone';
import Image from '../image/Image';
import Spinner from '../spinner/Spinner';
import { compressImage } from '../../utils/compress-image-utils';

const AvatarEditableWrapper = ({
    updateImage,
    cropHandler,
    onDropRejected,
    tmpImageUrl,
    isCroppingImage,
    isUploadingImage,
    onError,
    children,
}) => {
    const [showCropWindow, setShowCropWindow] = useState(false);
    const [isCompressingImage, setIsCompressingImage] = useState(false);

    const onDropAccepted = (files) => {
        if (!files || files.length === 0) {
            return;
        }

        setIsCompressingImage(true);
        compressImage(files[0])
            .then((compressedFile) => updateImage(compressedFile))
            .then(() => {
                setShowCropWindow(true);
            })
            .catch(() => {
                if (typeof onError === 'function') {
                    onError();
                }
                setShowCropWindow(false);
            })
            .finally(() => {
                setIsCompressingImage(false);
            });
    };

    const onSaveCropped = (crop) => {
        cropHandler(crop).then(() => {
            setShowCropWindow(false);
        });
    };

    const cancelCropButtonHandler = () => {
        setShowCropWindow(false);
    };

    return (
        <>
            <CropImage
                isOpen={showCropWindow && tmpImageUrl}
                cropImageHandler={onSaveCropped}
                cancelButtonHandler={cancelCropButtonHandler}
                imageUrl={tmpImageUrl}
                isSavingCroppedImage={isCroppingImage}
                startWidth={100}
                aspect={1}
            />
            <Dropzone
                inputProps={{ id: 'ImageInput' }}
                onDropAccepted={onDropAccepted}
                onDropRejected={onDropRejected}
                multiple={false}
                activeStyle={null}
                activeClassName={styles.dropzoneActive}
                className={styles.dropzone}
                accept={{
                    'image/jpeg': ['.jpeg', '.jpg'],
                    'image/jpg': ['.jpg'],
                    'image/png': ['.png'],
                    'image/webp': ['.webp'],
                }}
            >
                {({ getRootProps, getInputProps }) => (
                    <div {...getRootProps()} className={styles.relative} role="button">
                        <input {...getInputProps()} aria-label="Klikk her for å velge bilde du vil laste opp" />
                        {(isUploadingImage || isCroppingImage || isCompressingImage) && (
                            <div className={styles.spinnerContainer}>
                                <Spinner className={styles.spinner} size="50%" borderWidth="3px" color="#fff" />
                            </div>
                        )}
                        <div className={styles.hint}>
                            <Image src="camera.svg" alt="Camera" className={styles.hintIcon} />
                        </div>
                        {children}
                        <div
                            className={[
                                'ffe-button ffe-button--primary ffe-button--sm ffe-button--icon-only',
                                styles.editButton,
                            ].join(' ')}
                        >
                            <Icon fileUrl={editIcon} size="sm" className={styles.editIcon} aria-hidden={true} />
                        </div>
                    </div>
                )}
            </Dropzone>
        </>
    );
};

export default AvatarEditableWrapper;
